import useSWR from "swr"

export const useProject = (ticker) => {
    const { data: sparkline } = useSWR(ticker && `/api/getRecentPricesGraph?ticker=${ticker}`)

    return {
        sparkline
    }
}

export default useProject